"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkImporter = void 0;
var bookmarks_1 = require("../../../core/model/bookmarks");
var boundary_1 = require("@devexpress/utils/lib/intervals/boundary");
var string_1 = require("@devexpress/utils/lib/utils/map/string");
var BookmarkImporter = (function () {
    function BookmarkImporter(data) {
        this.data = data;
        this.bookmarks = {};
    }
    BookmarkImporter.prototype.insertBookmarks = function () {
        var _this = this;
        string_1.StringMapUtils.forEach(this.bookmarks, function (bkm) {
            if (bkm.validate(_this.data.subDocument))
                _this.data.subDocument.bookmarks.push(new bookmarks_1.Bookmark(_this.data.subDocument.positionManager, new boundary_1.BoundaryInterval(bkm.start, bkm.end), bkm.name));
        });
    };
    return BookmarkImporter;
}());
exports.BookmarkImporter = BookmarkImporter;
